import { Utils, NumberUtils } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { FreespinsController } from "./FreespinsController";
import { BetManager } from "../../Managers/BetManager";
import { DataManager } from "../../Managers/DataManager";
import { GameManager } from "../../Managers/GameManager";
import { MessageManager } from "../../Managers/MessageManager";

export class FreespinsModel {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    protected controller: FreespinsController;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor(controller: FreespinsController) {
        this.controller = controller;
    }

    //******************************************************************************************************************
    //  REQUESTS
    //******************************************************************************************************************

    public start(): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;
        DataManager.controlAutoplay();
        GameManager.gameClient.start(Communication.Game.GameModules.Freespins).then((response: any): any => {
            MessageManager.postpone(this.startReceived.bind(this), response);
        });
    }

    public spin(): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;
        DataManager.controlAutoplay();
        GameManager.gameClient.freespin(Communication.Game.GameModules.Freespins).then((response: any): any => {
            MessageManager.postpone(this.spinReceived.bind(this), response);
        });
    }

    public respin(): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;

        GameManager.gameClient
            .respin(Communication.Game.GameModules.Freespins, GameManager.freespinsResponse.respin)
            .then((response: any): any => {
                MessageManager.postpone(this.spinReceived.bind(this), response);
            });
    }

    public end(): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;
        DataManager.controlAutoplay();
        GameManager.gameClient.endFreespin().then((response: any): any => {
            MessageManager.postpone(this.endReceived.bind(this), response);
        });
    }

    //******************************************************************************************************************
    //  RESPONSES
    //******************************************************************************************************************

    protected startReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            Platforms.Platforms.featureStarted({ type: Communication.Game.GameModules.Freespins });
            this.controller.startReceived();
        }

        GameManager.requestSend = false;
    }

    protected spinReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            this.controller.spinReceived();
            Platforms.Platforms.spinReceived({
                balance: parseFloat(NumberUtils.add(response.balance.real, response.balance.bonus)),
                win: GameManager.freespinsResponse.currentWin,
                totalBet: BetManager.createBetForSpin().totalBet,
                roundId: response.roundId,
            });
        }

        GameManager.requestSend = false;
    }

    protected endReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            Platforms.Platforms.featureFinished({ type: Communication.Game.GameModules.Freespins });
            this.controller.endReceived();
        }

        GameManager.requestSend = false;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsModel.ts
 **/